const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:5000";

const request = async (endpoint, options = {}) => {
  const token = localStorage.getItem("auth_token");
  const headers = { ...options.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${endpoint}`, { ...options, headers });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "An error occurred");
  return data;
};

export const api = {
  login: (employee_id, password) => 
    request("/login", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ employee_id, password }) }),
  verifyOtp: (session_id, otp) => 
    request("/verify-otp", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ session_id, otp }) }),
  getCampaigns: () => request("/campaigns"),
  getCampaign: (id) => request(`/campaign/${id}`),
  uploadCampaign: (formData) => request("/upload", { method: "POST", body: formData }),
  sendCampaign: (id) => request(`/campaign/${id}/send`, { method: "POST" }),
  getCampaignStatus: (id) => request(`/campaign/${id}/status`),
  logout: () => { localStorage.removeItem("auth_token"); }
};